<template>

<div>{{user}}1111111111111111111111111</div>
</template>
<script>
import api from '@/modules/api.js'
export default {
  name: 'test2',
  data () {
    return {
      password: '',
      username: '',
      user: {
        manageCom: '1111', // 代理人的机构
        businessNo: '', // 代理人业务编码
        invalidator: '',
        agentCode: ''// 在登录会后存
      }
    }
  },
  components: {
  },
  methods: {
    check () {
//      this.user.agentCode = session.session_get('agentId')
      // todo... 单点验证，监考人信息是否正确
      let that = this
      // todo... 1.验证监考人与代理人的机构是否属于同一机构 2.成功-添加24小时时效的验证跳转页面，失败-返回失败
//      this.user.businessNo = session.session_get('businessNo')
      console.log(this.user.businessNo)
      api.invalidatorCheck(this.user, function (res) {
        console.log(res)
        if (res.data !== null) {
          that.user.manageCom = res.data
//          session.session_set('businessNo', res.data)
//          // that.show = true
//          that.$router.push({name: 'ExamTypeList'})
        } else {
          that.$toast('考生与监考人员需在同一分公司')
        }
      })
    }
  },
  mounted () {
    // this.$app.NaviInit.init('入司考试')
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{ //参数vm就是当前组件的实例。
        vm.check();
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/test/test2.vue